import { StudioLogger } from '@studio/logger/StudioLogger';
import { updateBackgroundSignedUrl } from '@studio/program/utils/scene';

import { withCurrentParams } from 'actions/utils';
import { BROADCAST_GET_SCENES, BROADCAST_SCENE_SYNC } from 'actions/Types';
import { DIRECTOR } from 'constants/BroadcastLogViews';

const logger = new StudioLogger('getOrSyncScenes');

/**
 * Get or Sync broadcast scene action
 *
 * @param {string} actionType
 */
export default actionType => {
  return withCurrentParams(
    (dispatch, { teamId, eventId, broadcastId }, getState) => {
      const isValidActionType = [
        BROADCAST_SCENE_SYNC,
        BROADCAST_GET_SCENES
      ].includes(actionType);

      if (!isValidActionType) {
        const logPayload = {
          view: DIRECTOR,
          reduxActionFired: actionType,
          title: `Received invalid action type, ${actionType}`
        };

        logger.error(logPayload.title, logPayload);
        return;
      }

      const { backgrounds } = getState();
      const action = {
        type: actionType,
        request: async apiClient => {
          const result = await apiClient.broadcastScene.getAll(
            teamId,
            eventId,
            broadcastId,
            {
              size: 200
            }
          );
          const scenes = updateBackgroundSignedUrl(result.scenes, backgrounds);
          // take out the scene updating
          return { scenes };
        }
      };
      dispatch(action);
    }
  );
};
